<template>
  <el-select v-model="selected"
             :collapse-tags="collapseTags"
             :filterable="filterable"
             :multiple="multiple"
             clearable="clearable"
             :popper-append-to-body="false"
             class="all-select-box">
    <el-option v-if="multiple && data.length"
               id="select-all"
               ref="all"
               :class="{'selected': isSelectedAll,'divide-line': divideAll}"
               :label="allLabel"
               disabled
               value="@all"
               @click.stop.native="isSelectedAll = !isSelectedAll">
    </el-option>
    <el-option v-for="item in data"
               :key="item[label] + item[_value]"
               :label="item[label]"
               :value="item[_value]">
    </el-option>
  </el-select>
</template>
 
<script>
export default {
  name: 'selectAll',
  model: {
    prop: 'value',
    event: 'v-model',
  },
  props: {
    // 全选框绑定值
    value: {
      type: Array,
      default: () => {
        return []
      },
    },
    // 是否可搜索
    filterable: {
      type: Boolean,
      default: false,
    },

    // 全选框数据
    data: {
      type: Array,
      default: () => {
        return []
      },
    },

    // 全选按钮标题
    allLabel: {
      type: String,
      default: '全部',
    },

    // 是否用线将全选与其它选项分割
    divideAll: {
      type: Boolean,
      default: false,
    },

    // 全选框对应配置
    option: {
      type: Object,
      default: () => ({
        // 设置label对应字段
        label: 'label',
        // 设置value对应字段
        value: 'value',
      }),
    },

    // el-select原生属性
    multiple: {
      type: Boolean,
      default: true,
    },
    collapseTags: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // 当前的选中项列表
    selected: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('v-model', v)
      },
    },
    // 当前是否全选
    isSelectedAll: {
      get() {
        return this.data.every((i) => this.selected.includes(i[this._value]))
      },
      set(v) {
        this.$emit('v-model', v ? this.data.map((i) => i[this._value]) : [])
      },
    },
    label() {
      return this.option.label || 'label'
    },
    _value() {
      return this.option.value || 'value'
    },
  },
}
</script>
 
<style scoped>
#select-all {
  cursor: pointer;
}

.divide-line {
  border-bottom: 1px solid rgba(123, 123, 123, 0.1);
}

#select-all:not(.selected) {
  color: #606266;
}

::v-deep .el-select-dropdown__item.hover {
  background-color: transparent !important;
}

#select-all:hover,
::v-deep .el-select-dropdown__item:hover {
  background-color: #f5f7fa !important;
}
::v-deep .el-select__tags-text {
  display: inline-block;
  max-width: 185px;
  @media (max-width: 1400px) {
    max-width: 42px;
  }
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.el-select .el-tag__close.el-icon-close {
  top: -7px;
  right: -4px;
}
</style>